import { takeLatest, put, call } from 'redux-saga/effects';
import swal from 'sweetalert';

import { history } from '@commons';

import { deleteNFeEmissao } from '../service';
import {
  DELETE_NFE_EMISSAO,
  DELETE_NFE_EMISSAO_PENDING,
  DELETE_NFE_EMISSAO_SUCCESS,
  DELETE_NFE_EMISSAO_FAILURE,
} from '../actionTypes';

import { AlertError } from '@components/common/AlertToast'
import { trackingEventCX, MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX';

function* sagaDeleteNFeEmissaoCadastro(action) {
  yield put({ type: DELETE_NFE_EMISSAO_PENDING, id: action.id })

  trackingEventCX('action', MODULE_ACTIONS_ENUM.NFE_PRODUTOR_EXCLUIR);

  try {
    const a = yield call(deleteNFeEmissao, action.id);

    if (a.status !== 204) {
      throw new Error('API delete request failed');
    }
    yield put({ type: DELETE_NFE_EMISSAO_SUCCESS, id: action.id });

    swal({
      title: 'NFe Excluída!',
      icon: 'success',
      buttons: {
        cancel: false,
        confirm: {
          text: 'OK',
          value: true,
          visible: true,
          className: 'btn-primary',
          closeModal: true
        }
      }
    }).then(() => {
      history.go(0)
    });

  } catch (error) {
    yield put({ type: DELETE_NFE_EMISSAO_FAILURE });

    AlertError('Falha ao excluir a NFe! Verifique se o status da NFe...');
  }
}

export default function* watchDeleteNFeEmissaoCadastro() {
  yield takeLatest(DELETE_NFE_EMISSAO, sagaDeleteNFeEmissaoCadastro)
}
